import openSocket from "socket.io-client";
import { SOCKET_URL, USER_UPDATE, USER_BALANCE_UPDATE, GATWAY_REPLY, GHL_CREATION_ACCOUNT_STATUS, GHL_SUBACCOUNT_LIST } from "constant/apiService";
import { cookie } from "utils/cookie";
import { AUTH_TOKEN, AUTH_USER_BALANCE, AUTH_USER_INFO } from "constant/constant";

export const socket = openSocket(SOCKET_URL, {
  secure: true,
  jsonp: false,
  path: "/socket.io",
  transports: ["websocket", "polling"],
  withCredentials: true,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

socket.on("connect", () => console.log("⚡ Sockets Connected ⚡"));
socket.on("disconnect", () => console.log("🔴 Sockets Disconnected 🔴"));
socket.on("connect_error", _ => console.error("❌ Socket connection error ❌", _));
class Socket {
  constructor({ state }) {
    this.io = null;
    this.state = state;
    this.startSocket();
  }

  startSocket() {
    socket.on(USER_UPDATE, user => {
      user = JSON.parse(user);
      console.log("⚡ User updated 👌");
      this.state.authStore.user = user;
      cookie.set(AUTH_USER_INFO, user);
    });

    socket.on(USER_BALANCE_UPDATE, data => {
      data = JSON.parse(data);
      console.log("⚡ Balance updated 👌");
      this.state.authStore.balanceObj = data;
      cookie.set(AUTH_USER_BALANCE, data);
    });

    // socket.on(GHL_CREATION_ACCOUNT_STATUS, data => {
    //   data = JSON.parse(data);
    //   console.log("⚡ GHL Account Creation Status 👌");
    //   this.state.integrationStore.afterAuthProcess = data;
    // });

    socket.on(GHL_SUBACCOUNT_LIST, data => {
      data = JSON.parse(data);
      console.log("⚡ Updating GHL Subaccount List 👌", data);
      this.state.integrationStore.updateGHLAccountStatus(data);
    });

    // Real-time inbound replies emitted by the backend's
    // gatewaymessage / gatewaymms change-stream watchers
    // (see guni-backend/src/events/aedes/user.events.js → NEW_REPLY_MESSAGE).
    //
    // Expected payload (already JSON-stringified on the wire):
    //   {
    //     listObj:         { receiver, sender, name, message, message_id, unread, createdAt, updatedAt, status, isSMS, isMMS },
    //     conversationObj: { _id, user, sender, receiver, message, status, isSMS, isMMS, createdAt, updatedAt },
    //     ...top-level fields kept for notifications
    //   }
    socket.on(GATWAY_REPLY, raw => {
      let messageObj;
      try {
        messageObj = typeof raw === "string" ? JSON.parse(raw) : raw;
      } catch (err) {
        console.error("❌ Failed to parse newReplyMessage payload", err, raw);
        return;
      }

      if (!messageObj?.listObj?.receiver) {
        console.warn("⚠️ newReplyMessage missing listObj.receiver, ignoring", messageObj);
        return;
      }

      // If the user already has this conversation open, don't bump the
      // unread badge — they're literally reading it right now.
      const selectedReceiver = this.state.messageStore?.selectedMessage?.receiver;
      const isViewingThisChat = !!selectedReceiver && selectedReceiver === messageObj.listObj.receiver;

      console.log("⚡ New reply received 👌", {
        from: messageObj.listObj.receiver,
        message: messageObj.listObj.message,
        isViewingThisChat
      });

      this.state.gatewayStore.newMessageEvent(messageObj, { isViewingThisChat });
      this.state.messageStore.newMessageEvent(messageObj);
      this.state.authStore.setuserNotificationList(messageObj);
      this.state.authStore.setnewUserNotification(true);
    });
  }
}

export default Socket;
